class JavaScriptErrorDetails {
    constructor() {
        this.LocationHref = null;
        this.AjaxUrl = null;
        this.AjaxData = null;
        this.ReadyState = null;
        this.StatusText = null;
        this.Status = null;
        this.Reason = null;
        this.Message = null;
        this.Filename = null;
        this.Lineno = null;
        this.Colno = null;
        this.Error = null;
        this.Navigator = null;
    }
}
class NavigatorDetails {
    constructor() {
        this.AppCodename = null;
        this.AppName = null;
        this.AppVersion = null;
        this.Platform = null;
        this.Product = null;
        this.UserAgent = null;
        this.Brands = null;
    }
}
class MyError {
    constructor() {
        this.Name = null;
        this.Message = null;
        this.Code = null;
        this.Stack = null;
    }
}
class BrandDetails {
    constructor() {
        this.Brand = null;
        this.Version = null;
    }
}
export class ErrorReporter {
    static ReportAjaxError(ajaxUrl, ajaxData, res) {
        try {
            if (!ajaxData)
                ajaxData = 'No data';
            else {
                try {
                    ajaxData = JSON.stringify(ajaxData);
                }
                catch (ex) {
                    ajaxData = 'Could not stringify data';
                }
            }
            let errorDetails = {
                LocationHref: window.location.href,
                AjaxUrl: ajaxUrl,
                AjaxData: ajaxData,
                ReadyState: res && res.readyState,
                Status: res && res.status,
                StatusText: res && res.statusText,
                Navigator: ErrorReporter.GetNavigatorData()
            };
            console.error("Ajax error: ", errorDetails);
            $.ajax({
                url: ErrorReporter.Url,
                method: "POST",
                contentType: 'application/json',
                data: JSON.stringify(errorDetails),
                dataType: "json"
            });
        }
        catch (ex) {
            console.error("Error reporting Ajax error", ex);
        }
    }
    static ReportError(statusText) {
        try {
            let errorDetails = {
                LocationHref: window.location.href,
                StatusText: statusText,
                Navigator: ErrorReporter.GetNavigatorData()
            };
            console.error("Error: ", errorDetails);
            $.ajax({
                url: ErrorReporter.Url,
                method: "POST",
                contentType: 'application/json',
                data: JSON.stringify(errorDetails),
                dataType: "json"
            });
        }
        catch (ex) {
            console.error("Error reporting error", ex);
        }
    }
    static ReportErrorWithReadyData(statusText, errorDetails, shallLogErrorInConsole) {
        try {
            errorDetails.StatusText = statusText;
            errorDetails.Navigator = ErrorReporter.GetNavigatorData();
            if (shallLogErrorInConsole)
                console.error("Error with ready data: ", errorDetails);
            $.ajax({
                url: ErrorReporter.Url,
                method: "POST",
                contentType: 'application/json',
                data: JSON.stringify(errorDetails),
                dataType: "json"
            });
        }
        catch (ex) {
            console.error("Error reporting error", ex);
        }
    }
    static GetNavigatorData() {
        try {
            let brandsFromBrowser = window.navigator?.userAgentData?.brands;
            let brands = brandsFromBrowser
                ? brandsFromBrowser.map((b) => ({
                    brand: b.brand,
                    version: b.version
                }))
                : null;
            let navigatorDetails = {
                AppCodename: window.navigator && window.navigator.appCodeName,
                AppName: window.navigator && window.navigator.appName,
                AppVersion: window.navigator && window.navigator.appVersion,
                Platform: window.navigator && window.navigator.platform,
                Product: window.navigator && window.navigator.product,
                UserAgent: window.navigator && window.navigator.userAgent,
                Brands: brands
            };
            return navigatorDetails;
        }
        catch (ex) {
            console.error("Error getting navigator data", ex);
            return null;
        }
    }
    static RegisterGlobalErrorHandlers() {
        window.addEventListener('error', function (event) {
            let error = {
                Name: event.error?.name,
                Message: event.error?.message,
                Code: event.error?.code,
                Stack: event.error?.stack
            };
            let isErrorEmpty = !error.Name && !error.Message && !error.Code && !error.Stack;
            if (!isErrorEmpty) {
                let errorDetails = {
                    LocationHref: window.location.href,
                    Message: event.message,
                    Filename: event.filename,
                    Lineno: event.lineno,
                    Colno: event.colno,
                    Error: error
                };
                ErrorReporter.ReportErrorWithReadyData("Unhandled error from listener", errorDetails, false);
            }
        });
        window.addEventListener('unhandledrejection', function (event) {
            let errorDetails = {
                LocationHref: window.location.href,
                Reason: event.reason,
            };
        });
    }
}
window.ErrorReporter = ErrorReporter;
